import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

interface IResponse {
    email?: string;
    verified: boolean;
}

export async function sendEmailVerificationCode(email: string) {
    try {
        const { data } = await axios.post<IResponse>(Endpoints.User.Email, { email });

        return data.verified;
    } catch (error) {
        return false;
    }
}
